import _ from 'lodash';
import options, { selectionModelCont } from '@/app/utils/toolkit/business-rules/inv-strat-review/reviewReasons';

const mStep = {
  title: 'Specific Review - Continued',
  description: 'Please provide details of the investment strategy review.',
};

const intro = {
  'Asset Allocations': 'The Fund is currently investing outside its stated investment strategy asset allocation ranges but the Trustee considers that:',
  'Cash Flow': 'The Fund is currently experiencing cash flow issues but the Trustee considers that:',
  'Asset Values': 'The overall value of the Fund\'s assets has materially declined but the Trustee considers that:',
  Income: 'The Fund\'s income has materially declined but the Trustee considers that:',
  'Structural Changes': 'The Fund\'s membership or benefit structure has changed but the Trustee considers that:',
};

export default {
  name: 'inv-strat-review-specific-review-cont',
  data: () => ({
    mStep,
    selections: _.cloneDeep(selectionModelCont()),
  }),
  computed: {
    getItem() {
      return _.cloneDeep(this.$store.getters['toolkit/getItemData']);
    },
    reviewReasons() {
      return this.getItem.review.specific.reasons;
    },
    sectionReasons() {
      return this.getItem.review.specific.sectionReasons;
    },
    activeSelections() {
      return Object.keys(this.reviewReasons)
        // Filter the selections to those that have an active selection
        .filter((section) => {
          const selections = Object.keys(this.reviewReasons[section]).filter((option) => {
            if (this.reviewReasons[section][option].selection instanceof Array) {
              return this.reviewReasons[section][option].selection.length > 0;
            }
            return this.reviewReasons[section][option].selection;
          });
          return selections.length > 0;
        })
        // manipulate the object to use in this component
        .map(section => ({
          [section]: Object.keys(this.reviewReasons[section]).filter((option) => {
            if (this.reviewReasons[section][option].selection instanceof Array) {
              return this.reviewReasons[section][option].selection.length > 0;
            }
            return this.reviewReasons[section][option].selection;
          })
            .flatMap((option) => {
              if (this.reviewReasons[section][option].selection instanceof Array) {
                return [option, ...this.reviewReasons[section][option].selection];
              }
              return option;
            }),
        }));
    },
    options() {
      return options
        .filter(section => this.activeSelections
          .find(selection => Object.keys(selection).includes(section.label)))
        .map((section) => {
          const selected = this.activeSelections
            .find(selection => Object.keys(selection).includes(section.label));
          const selectedOptions = section.options
            .filter(option => selected[section.label].includes(option.value));

          const reviewOptions = selectedOptions.flatMap((option) => {
            if (option.children) {
              const childFollowUp = option.children
                .filter(child => selected[section.label].includes(child.value))
                .flatMap(child => (child.followUp ? child.followUp : []));
              return childFollowUp.length > 0
                ? [...childFollowUp, ...option.followUp]
                : [...option.followUp];
            }
            return option.followUp;
          });

          if (section.label === 'Structural Changes') {
            reviewOptions.push('other');
          }
          return {
            label: section.label,
            options: reviewOptions,
          };
        });
    },
  },
  watch: {
    selections: {
      handler(value) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key of Object.keys(value)) {
          if (!value[key].selections.includes('other')) {
            value[key].other = '';
          }
        }
        this.setItem({ review: { specific: { sectionReasons: _.cloneDeep(value) } } });
      },
      deep: true,
    },
  },
  methods: {
    getIntroByLabel(label) {
      return intro[label];
    },
    setItem(item) {
      this.$store.dispatch('toolkit/updateItemKey', { data: item });
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
    handleBackStep() {
      this.$emit('backStep');
    },
  },
  activated() {
    if (Object.keys(this.sectionReasons).length > 0) {
      this.selections = _.cloneDeep(this.sectionReasons);
    }
  },
  validations: {
    selections: {
      hasSelection(value) {
        const selectionCount = Object.keys(value).reduce((prev, curr) => {
          if (value[curr].selections.length > 0) {
            return prev + 1;
          }
          return prev;
        }, 0);
        return this.activeSelections.length === selectionCount;
      },
    },

  },
};
